import React, { useState, useEffect } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

// Phase 2C-5 · Minimal reason-confirm dialog for controlled Hold / Release Hold.
// Backend enforces all rules; this only collects a mandatory reason and POSTs.
export default function HoldReasonDialog({ open, onClose, title, actionLabel, endpoint, onDone }) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setReason(""); }, [open]);
  if (!open) return null;

  const submit = async () => {
    if (reason.trim().length < 4) { toast.error("Reason must be at least 4 characters"); return; }
    setBusy(true);
    try {
      await api.post(endpoint, { reason: reason.trim() });
      toast.success(`${actionLabel} successful`);
      onDone?.();
      onClose?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || `${actionLabel} failed`);
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-black/60 p-4" data-testid="hold-reason-overlay">
      <div className="w-full max-w-md bg-[var(--bg)] border border-[var(--border)] rounded-md p-5" data-testid="hold-reason-dialog">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-semibold">{title}</h3>
          <button onClick={onClose} className="text-sm opacity-70 hover:opacity-100" data-testid="hold-reason-close">✕</button>
        </div>
        <label className="block text-xs mb-1 opacity-80">Reason <span className="text-red-400">*</span></label>
        <input data-testid="hold-reason-input" type="text" value={reason} onChange={e => setReason(e.target.value)}
          placeholder="Min 4 characters"
          className="w-full h-9 px-2 bg-[var(--surface)] border border-[var(--border)] rounded-sm text-sm" />
        <div className="flex justify-end gap-2 mt-4">
          <button onClick={onClose} className="h-9 px-4 border border-[var(--border)] text-sm rounded-sm" data-testid="hold-reason-cancel">Cancel</button>
          <button onClick={submit} disabled={busy || reason.trim().length < 4}
            className="h-9 px-4 bg-amber-600 hover:bg-amber-700 text-white text-sm font-semibold rounded-sm disabled:opacity-40"
            data-testid="hold-reason-submit">{busy ? "Working…" : actionLabel}</button>
        </div>
      </div>
    </div>
  );
}
